import P from '../../pages';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { defaultMessages } from '../../../../libs/i18n/default';
import FormHeader from './FormHeader';
import Redirector from './Redirector';
import Alert from './Alert';
import ButtonGroup from './ButtonGroup';
import Cigarette from 'react-icons/lib/md/smoking-rooms';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import ProfileElementField from './ProfileElementField';
import { validator, fieldsToValidate, pageValid, executeValidations } from '../../validator';
import { generateProfileElementObject, changeState } from '../../utilities';

class Smoking extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      smokers: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','smokers'),
      vapers: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','vapers'),
      guestsCanSmoke: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','guests_can_smoke'),
      guestsCanVape: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','guests_can_vape'),
      alcoholInHome: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','alcohol_in_home'),
      guestsCanDrink: generateProfileElementObject(this.props.profileElements, this.props.activeProfileElements,'','lifestyle','guests_consume_alcohol')
    };
    this.submit = this.submit.bind(this);
    this.back = this.back.bind(this);
    this.pageTitle = this.pageTitle.bind(this);
    this.changeState = this.changeState.bind(this);
  }

  componentWillMount(){
    executeValidations(this)
  }

  changeState = async(id, val) => {
    changeState(this, id, val)
  }

  back(e) {
    this.props.onGoBack();
  }

  submit(e) {
    this.props.onHostProfileSubmit({
      lifestyle: {
        smokers: this.state.smokers.val,
        vapers: this.state.vapers.val,
        guests_can_smoke: this.state.guestsCanSmoke.val,
        guests_can_vape: this.state.guestsCanVape.val,
        alcohol_in_home: this.state.alcoholInHome.val,
        guests_consume_alcohol: this.state.guestsCanDrink.val
      }
    });
  }
  pageTitle(){
    const elements = this.props.activeProfileElements
    const content = this.props.content
    if (elements.includes('alcohol_in_home') || elements.includes('guests_consume_alcohol')){
      return content.pages.smoking.smoking_alcohol
    } else {
      return content.pages.smoking.smoking
    }
  }

  render() {
    const thisPage = P.SMOKING_PAGE;
    const { formatMessage } = this.props.intl;
    const content = this.props.content;
    const page = this.props.page;

    return (
      <div id={page} className='profile'>
        <Redirector this_page={thisPage} page={page}/>

        <form>
          <FormHeader title={this.pageTitle()} icon={<Cigarette />}/>

          <CheckboxOrRadioGroup
            title={formatMessage(defaultMessages.clientHostPagesSmokingLabelsHosts)}
            setId={'smokers'}
            setName={'smokers'}
            type={'radio'}
            checkBoxStyle={'radio-inline'}
            controlFunc={(e) => this.changeState('smokers', e.target.value == 'true')}
            valid={this.state.smokers.valid}
            options={[
              [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
              [formatMessage(defaultMessages.clientCommonNegative), 'false']
            ]}
            selectedOptions={[String(this.state.smokers.val)]} />

          
          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={formatMessage(defaultMessages.clientHostPagesSmokingLabelsVapers)}
                setId={'vapers'}
                setName={'vapers'}
                type={'radio'}
                checkBoxStyle={'radio-inline'}
                controlFunc={(e) => this.changeState('vapers', e.target.value == 'true')}
                valid={this.state.vapers.valid}
                options={[
                  [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                  [formatMessage(defaultMessages.clientCommonNegative), 'false']
                ]}
                selectedOptions={[String(this.state.vapers.val)]} />
            }
            elementName={'vapers'}
          />

          <CheckboxOrRadioGroup
            title={content.pages.smoking.guests}
            setId={'guestsCanSmoke'}
            setName={'guestsCanSmoke'}
            type={'radio'}
            checkBoxStyle={'radio-inline'}
            controlFunc={(e) => this.changeState('guestsCanSmoke', e.target.value)}
            valid={this.state.guestsCanSmoke.valid}
            options={[
              [formatMessage(defaultMessages.clientCommonAffirmative), 'Outside'],
              [formatMessage(defaultMessages.clientCommonNegative), 'No']
            ]}
            selectedOptions={[this.state.guestsCanSmoke.val]} />

          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={formatMessage(defaultMessages.clientHostPagesSmokingLabelsGuestsCanVape)}
                setId={'guestsCanVape'}
                setName={'guestsCanVape'}
                type={'radio'}
                checkBoxStyle={'radio-inline'}
                controlFunc={(e) => this.changeState('guestsCanVape', e.target.value == 'true')}
                valid={this.state.guestsCanVape.valid}
                options={[
                  [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                  [formatMessage(defaultMessages.clientCommonNegative), 'false']
                ]}
                selectedOptions={[String(this.state.guestsCanVape.val)]} />
            }
            elementName={'guests_can_vape'}
          />

          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={`Does anyone in your home drink alcohol?`}
                setId={'alcoholInHome'}
                setName={'alcoholInHome'}
                type={'radio'}
                checkBoxStyle={'radio-inline'}
                controlFunc={(e) => this.changeState('alcoholInHome', e.target.value == 'true')}
                valid={this.state.alcoholInHome.valid}
                options={[
                  [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                  [formatMessage(defaultMessages.clientCommonNegative), 'false']
                ]}
                selectedOptions={[String(this.state.alcoholInHome.val)]} />
            }
            elementName={'alcohol_in_home'} />

          <ProfileElementField
            childComponent={
              <CheckboxOrRadioGroup
                title={`Are guests allowed to drink alcohol in your home?`}
                setId={'guestsCanDrink'}
                setName={'guestsCanDrink'}
                type={'radio'}
                checkBoxStyle={'radio-inline'}
                controlFunc={(e) => this.changeState('guestsCanDrink', e.target.value == 'true')}
                valid={this.state.guestsCanDrink.valid}
                options={[
                  [formatMessage(defaultMessages.clientCommonAffirmative), 'true'],
                  [formatMessage(defaultMessages.clientCommonNegative), 'false']
                ]}
                selectedOptions={[String(this.state.guestsCanDrink.val)]} />
            }
            elementName={'guests_consume_alcohol'} />

          <Alert alert={content.pages.smoking.info} />

          <ButtonGroup
            backFunc={this.back}
            submitFunc={this.submit}
            disableSubmit={!pageValid(this.state, this.props.requiredFields)}
            page={thisPage}
            user={this.props.user}
            intl={this.props.intl} />

        </form>
      </div>
    );
  }
}

Smoking.propTypes = {
   onHostProfileSubmit: PropTypes.func,
   onSkipSubmit: PropTypes.func,
   onGoBack: PropTypes.func,
   page: PropTypes.string,
   intl: PropTypes.object,
   content: PropTypes.object
};

export default injectIntl(Smoking);
